const icon_tongyong_1_blue = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-1-blue.svg`);
const icon_tongyong_1_green = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-1-green.svg`);
const icon_tongyong_1_purple = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-1-purple.svg`);
const icon_tongyong_1_red = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-1-red.svg`);
const icon_tongyong_1_yellow = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-1-yellow.svg`);
const icon_tongyong_2_blue = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-2-blue.svg`);
const icon_tongyong_2_green = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-2-green.svg`);
const icon_tongyong_2_purple = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-2-purple.svg`);
const icon_tongyong_2_red = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-2-red.svg`);
const icon_tongyong_2_yellow = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-2-yellow.svg`);
const icon_tongyong_3_blue = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-3-blue.svg`);
const icon_tongyong_3_green = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-3-green.svg`);
const icon_tongyong_3_purple = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-3-purple.svg`);
const icon_tongyong_3_red = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-3-red.svg`);
const icon_tongyong_3_yellow = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-3-yellow.svg`);
const icon_tongyong_4_blue = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-4-blue.svg`);
const icon_tongyong_4_green = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-4-green.svg`);
const icon_tongyong_4_purple = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-4-purple.svg`);
const icon_tongyong_4_red = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-4-red.svg`);
const icon_tongyong_4_yellow = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-4-yellow.svg`);

const icon_renyuan_1_blue = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-1-blue.svg`);
const icon_renyuan_1_green = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-1-green.svg`);
const icon_renyuan_1_purple = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-1-purple.svg`);
const icon_renyuan_1_red = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-1-red.svg`);
const icon_renyuan_1_yellow = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-1-yellow.svg`);
const icon_renyuan_2_blue = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-2-blue.svg`);
const icon_renyuan_2_green = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-2-green.svg`);
const icon_renyuan_2_purple = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-2-purple.svg`);
const icon_renyuan_2_red = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-2-red.svg`);
const icon_renyuan_2_yellow = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-2-yellow.svg`);
const icon_renyuan_3_blue = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-3-blue.svg`);
const icon_renyuan_3_green = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-3-green.svg`);
const icon_renyuan_3_purple = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-3-purple.svg`);
const icon_renyuan_3_red = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-3-red.svg`);
const icon_renyuan_3_yellow = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-3-yellow.svg`);
const icon_renyuan_4_blue = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-4-blue.svg`);
const icon_renyuan_4_green = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-4-green.svg`);
const icon_renyuan_4_purple = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-4-purple.svg`);
const icon_renyuan_4_red = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-4-red.svg`);
const icon_renyuan_4_yellow = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-4-yellow.svg`);

const icon_riqi_1_blue = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-1-blue.svg`);
const icon_riqi_1_green = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-1-green.svg`);
const icon_riqi_1_purple = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-1-purple.svg`);
const icon_riqi_1_red = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-1-red.svg`);
const icon_riqi_1_yellow = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-1-yellow.svg`);
const icon_riqi_2_blue = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-2-blue.svg`);
const icon_riqi_2_green = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-2-green.svg`);
const icon_riqi_2_purple = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-2-purple.svg`);
const icon_riqi_2_red = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-2-red.svg`);
const icon_riqi_2_yellow = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-2-yellow.svg`);
const icon_riqi_3_blue = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-3-blue.svg`);
const icon_riqi_3_green = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-3-green.svg`);
const icon_riqi_3_purple = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-3-purple.svg`);
const icon_riqi_3_red = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-3-red.svg`);
const icon_riqi_3_yellow = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-3-yellow.svg`);
const icon_riqi_4_blue = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-4-blue.svg`);
const icon_riqi_4_green = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-4-green.svg`);
const icon_riqi_4_purple = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-4-purple.svg`);
const icon_riqi_4_red = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-4-red.svg`);
const icon_riqi_4_yellow = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-4-yellow.svg`);

const icon_shuzhi_1_blue = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-1-blue.svg`);
const icon_shuzhi_1_green = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-1-green.svg`);
const icon_shuzhi_1_purple = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-1-purple.svg`);
const icon_shuzhi_1_red = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-1-red.svg`);
const icon_shuzhi_1_yellow = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-1-yellow.svg`);
const icon_shuzhi_2_blue = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-2-blue.svg`);
const icon_shuzhi_2_green = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-2-green.svg`);
const icon_shuzhi_2_purple = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-2-purple.svg`);
const icon_shuzhi_2_red = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-2-red.svg`);
const icon_shuzhi_2_yellow = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-2-yellow.svg`);
const icon_shuzhi_3_blue = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-3-blue.svg`);
const icon_shuzhi_3_green = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-3-green.svg`);
const icon_shuzhi_3_purple = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-3-purple.svg`);
const icon_shuzhi_3_red = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-3-red.svg`);
const icon_shuzhi_3_yellow = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-3-yellow.svg`);
const icon_shuzhi_4_blue = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-4-blue.svg`);
const icon_shuzhi_4_green = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-4-green.svg`);
const icon_shuzhi_4_purple = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-4-purple.svg`);
const icon_shuzhi_4_red = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-4-red.svg`);
const icon_shuzhi_4_yellow = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-4-yellow.svg`);

const icon_zhuangtai_1_blue = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-1-blue.svg`);
const icon_zhuangtai_1_green = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-1-green.svg`);
const icon_zhuangtai_1_purple = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-1-purple.svg`);
const icon_zhuangtai_1_red = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-1-red.svg`);
const icon_zhuangtai_1_yellow = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-1-yellow.svg`);
const icon_zhuangtai_2_blue = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-2-blue.svg`);
const icon_zhuangtai_2_green = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-2-green.svg`);
const icon_zhuangtai_2_purple = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-2-purple.svg`);
const icon_zhuangtai_2_red = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-2-red.svg`);
const icon_zhuangtai_2_yellow = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-2-yellow.svg`);
const icon_zhuangtai_3_blue = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-3-blue.svg`);
const icon_zhuangtai_3_green = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-3-green.svg`);
const icon_zhuangtai_3_purple = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-3-purple.svg`);
const icon_zhuangtai_3_red = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-3-red.svg`);
const icon_zhuangtai_3_yellow = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-3-yellow.svg`);
const icon_zhuangtai_4_blue = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-4-blue.svg`);
const icon_zhuangtai_4_green = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-4-green.svg`);
const icon_zhuangtai_4_purple = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-4-purple.svg`);
const icon_zhuangtai_4_red = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-4-red.svg`);
const icon_zhuangtai_4_yellow = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-4-yellow.svg`);

const icon_zuzhi_1_blue = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-1-blue.svg`);
const icon_zuzhi_1_green = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-1-green.svg`);
const icon_zuzhi_1_purple = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-1-purple.svg`);
const icon_zuzhi_1_red = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-1-red.svg`);
const icon_zuzhi_1_yellow = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-1-yellow.svg`);
const icon_zuzhi_2_blue = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-2-blue.svg`);
const icon_zuzhi_2_green = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-2-green.svg`);
const icon_zuzhi_2_purple = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-2-purple.svg`);
const icon_zuzhi_2_red = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-2-red.svg`);
const icon_zuzhi_2_yellow = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-2-yellow.svg`);
const icon_zuzhi_3_blue = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-3-blue.svg`);
const icon_zuzhi_3_green = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-3-green.svg`);
const icon_zuzhi_3_purple = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-3-purple.svg`);
const icon_zuzhi_3_red = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-3-red.svg`);
const icon_zuzhi_3_yellow = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-3-yellow.svg`);
const icon_zuzhi_4_blue = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-4-blue.svg`);
const icon_zuzhi_4_green = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-4-green.svg`);
const icon_zuzhi_4_purple = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-4-purple.svg`);
const icon_zuzhi_4_red = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-4-red.svg`);
const icon_zuzhi_4_yellow = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-4-yellow.svg`);

const bipg_tongyong_1_blue = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-1-blue.svg`);
const bipg_tongyong_1_green = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-1-green.svg`);
const bipg_tongyong_1_purple = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-1-purple.svg`);
const bipg_tongyong_1_red = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-1-red.svg`);
const bipg_tongyong_1_yellow = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-1-yellow.svg`);
const bipg_tongyong_2_blue = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-2-blue.svg`);
const bipg_tongyong_2_green = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-2-green.svg`);
const bipg_tongyong_2_purple = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-2-purple.svg`);
const bipg_tongyong_2_red = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-2-red.svg`);
const bipg_tongyong_2_yellow = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-2-yellow.svg`);
const bipg_tongyong_3_blue = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-3-blue.svg`);
const bipg_tongyong_3_green = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-3-green.svg`);
const bipg_tongyong_3_purple = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-3-purple.svg`);
const bipg_tongyong_3_red = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-3-red.svg`);
const bipg_tongyong_3_yellow = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-3-yellow.svg`);
const bipg_tongyong_4_blue = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-4-blue.svg`);
const bipg_tongyong_4_green = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-4-green.svg`);
const bipg_tongyong_4_purple = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-4-purple.svg`);
const bipg_tongyong_4_red = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-4-red.svg`);
const bipg_tongyong_4_yellow = require(`../../../../static/images/pageMainIcon/tongyong/icon-tongyong-4-yellow.svg`);

const bipg_renyuan_1_blue = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-1-blue.svg`);
const bipg_renyuan_1_green = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-1-green.svg`);
const bipg_renyuan_1_purple = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-1-purple.svg`);
const bipg_renyuan_1_red = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-1-red.svg`);
const bipg_renyuan_1_yellow = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-1-yellow.svg`);
const bipg_renyuan_2_blue = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-2-blue.svg`);
const bipg_renyuan_2_green = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-2-green.svg`);
const bipg_renyuan_2_purple = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-2-purple.svg`);
const bipg_renyuan_2_red = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-2-red.svg`);
const bipg_renyuan_2_yellow = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-2-yellow.svg`);
const bipg_renyuan_3_blue = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-3-blue.svg`);
const bipg_renyuan_3_green = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-3-green.svg`);
const bipg_renyuan_3_purple = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-3-purple.svg`);
const bipg_renyuan_3_red = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-3-red.svg`);
const bipg_renyuan_3_yellow = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-3-yellow.svg`);
const bipg_renyuan_4_blue = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-4-blue.svg`);
const bipg_renyuan_4_green = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-4-green.svg`);
const bipg_renyuan_4_purple = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-4-purple.svg`);
const bipg_renyuan_4_red = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-4-red.svg`);
const bipg_renyuan_4_yellow = require(`../../../../static/images/pageMainIcon/renyuan/icon-renyuan-4-yellow.svg`);

const bipg_riqi_1_blue = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-1-blue.svg`);
const bipg_riqi_1_green = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-1-green.svg`);
const bipg_riqi_1_purple = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-1-purple.svg`);
const bipg_riqi_1_red = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-1-red.svg`);
const bipg_riqi_1_yellow = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-1-yellow.svg`);
const bipg_riqi_2_blue = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-2-blue.svg`);
const bipg_riqi_2_green = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-2-green.svg`);
const bipg_riqi_2_purple = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-2-purple.svg`);
const bipg_riqi_2_red = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-2-red.svg`);
const bipg_riqi_2_yellow = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-2-yellow.svg`);
const bipg_riqi_3_blue = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-3-blue.svg`);
const bipg_riqi_3_green = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-3-green.svg`);
const bipg_riqi_3_purple = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-3-purple.svg`);
const bipg_riqi_3_red = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-3-red.svg`);
const bipg_riqi_3_yellow = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-3-yellow.svg`);
const bipg_riqi_4_blue = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-4-blue.svg`);
const bipg_riqi_4_green = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-4-green.svg`);
const bipg_riqi_4_purple = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-4-purple.svg`);
const bipg_riqi_4_red = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-4-red.svg`);
const bipg_riqi_4_yellow = require(`../../../../static/images/pageMainIcon/riqi/icon-riqi-4-yellow.svg`);

const bipg_shuzhi_1_blue = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-1-blue.svg`);
const bipg_shuzhi_1_green = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-1-green.svg`);
const bipg_shuzhi_1_purple = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-1-purple.svg`);
const bipg_shuzhi_1_red = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-1-red.svg`);
const bipg_shuzhi_1_yellow = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-1-yellow.svg`);
const bipg_shuzhi_2_blue = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-2-blue.svg`);
const bipg_shuzhi_2_green = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-2-green.svg`);
const bipg_shuzhi_2_purple = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-2-purple.svg`);
const bipg_shuzhi_2_red = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-2-red.svg`);
const bipg_shuzhi_2_yellow = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-2-yellow.svg`);
const bipg_shuzhi_3_blue = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-3-blue.svg`);
const bipg_shuzhi_3_green = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-3-green.svg`);
const bipg_shuzhi_3_purple = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-3-purple.svg`);
const bipg_shuzhi_3_red = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-3-red.svg`);
const bipg_shuzhi_3_yellow = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-3-yellow.svg`);
const bipg_shuzhi_4_blue = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-4-blue.svg`);
const bipg_shuzhi_4_green = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-4-green.svg`);
const bipg_shuzhi_4_purple = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-4-purple.svg`);
const bipg_shuzhi_4_red = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-4-red.svg`);
const bipg_shuzhi_4_yellow = require(`../../../../static/images/pageMainIcon/shuzhi/icon-shuzhi-4-yellow.svg`);

const bipg_zhuangtai_1_blue = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-1-blue.svg`);
const bipg_zhuangtai_1_green = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-1-green.svg`);
const bipg_zhuangtai_1_purple = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-1-purple.svg`);
const bipg_zhuangtai_1_red = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-1-red.svg`);
const bipg_zhuangtai_1_yellow = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-1-yellow.svg`);
const bipg_zhuangtai_2_blue = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-2-blue.svg`);
const bipg_zhuangtai_2_green = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-2-green.svg`);
const bipg_zhuangtai_2_purple = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-2-purple.svg`);
const bipg_zhuangtai_2_red = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-2-red.svg`);
const bipg_zhuangtai_2_yellow = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-2-yellow.svg`);
const bipg_zhuangtai_3_blue = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-3-blue.svg`);
const bipg_zhuangtai_3_green = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-3-green.svg`);
const bipg_zhuangtai_3_purple = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-3-purple.svg`);
const bipg_zhuangtai_3_red = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-3-red.svg`);
const bipg_zhuangtai_3_yellow = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-3-yellow.svg`);
const bipg_zhuangtai_4_blue = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-4-blue.svg`);
const bipg_zhuangtai_4_green = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-4-green.svg`);
const bipg_zhuangtai_4_purple = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-4-purple.svg`);
const bipg_zhuangtai_4_red = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-4-red.svg`);
const bipg_zhuangtai_4_yellow = require(`../../../../static/images/pageMainIcon/zhuangtai/icon-zhuangtai-4-yellow.svg`);

const bipg_zuzhi_1_blue = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-1-blue.svg`);
const bipg_zuzhi_1_green = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-1-green.svg`);
const bipg_zuzhi_1_purple = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-1-purple.svg`);
const bipg_zuzhi_1_red = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-1-red.svg`);
const bipg_zuzhi_1_yellow = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-1-yellow.svg`);
const bipg_zuzhi_2_blue = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-2-blue.svg`);
const bipg_zuzhi_2_green = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-2-green.svg`);
const bipg_zuzhi_2_purple = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-2-purple.svg`);
const bipg_zuzhi_2_red = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-2-red.svg`);
const bipg_zuzhi_2_yellow = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-2-yellow.svg`);
const bipg_zuzhi_3_blue = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-3-blue.svg`);
const bipg_zuzhi_3_green = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-3-green.svg`);
const bipg_zuzhi_3_purple = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-3-purple.svg`);
const bipg_zuzhi_3_red = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-3-red.svg`);
const bipg_zuzhi_3_yellow = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-3-yellow.svg`);
const bipg_zuzhi_4_blue = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-4-blue.svg`);
const bipg_zuzhi_4_green = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-4-green.svg`);
const bipg_zuzhi_4_purple = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-4-purple.svg`);
const bipg_zuzhi_4_red = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-4-red.svg`);
const bipg_zuzhi_4_yellow = require(`../../../../static/images/pageMainIcon/zuzhi/icon-zuzhi-4-yellow.svg`);

export {
    icon_tongyong_1_blue,
    icon_tongyong_1_green,
    icon_tongyong_1_purple,
    icon_tongyong_1_red,
    icon_tongyong_1_yellow,
    icon_tongyong_2_blue,
    icon_tongyong_2_green,
    icon_tongyong_2_purple,
    icon_tongyong_2_red,
    icon_tongyong_2_yellow,
    icon_tongyong_3_blue,
    icon_tongyong_3_green,
    icon_tongyong_3_purple,
    icon_tongyong_3_red,
    icon_tongyong_3_yellow,
    icon_tongyong_4_blue,
    icon_tongyong_4_green,
    icon_tongyong_4_purple,
    icon_tongyong_4_red,
    icon_tongyong_4_yellow,
    
    icon_renyuan_1_blue,
    icon_renyuan_1_green,
    icon_renyuan_1_purple,
    icon_renyuan_1_red,
    icon_renyuan_1_yellow,
    icon_renyuan_2_blue,
    icon_renyuan_2_green,
    icon_renyuan_2_purple,
    icon_renyuan_2_red,
    icon_renyuan_2_yellow,
    icon_renyuan_3_blue,
    icon_renyuan_3_green,
    icon_renyuan_3_purple,
    icon_renyuan_3_red,
    icon_renyuan_3_yellow,
    icon_renyuan_4_blue,
    icon_renyuan_4_green,
    icon_renyuan_4_purple,
    icon_renyuan_4_red,
    icon_renyuan_4_yellow,
    
    icon_riqi_1_blue,
    icon_riqi_1_green,
    icon_riqi_1_purple,
    icon_riqi_1_red,
    icon_riqi_1_yellow,
    icon_riqi_2_blue,
    icon_riqi_2_green,
    icon_riqi_2_purple,
    icon_riqi_2_red,
    icon_riqi_2_yellow,
    icon_riqi_3_blue,
    icon_riqi_3_green,
    icon_riqi_3_purple,
    icon_riqi_3_red,
    icon_riqi_3_yellow,
    icon_riqi_4_blue,
    icon_riqi_4_green,
    icon_riqi_4_purple,
    icon_riqi_4_red,
    icon_riqi_4_yellow,
    
    icon_shuzhi_1_blue,
    icon_shuzhi_1_green,
    icon_shuzhi_1_purple,
    icon_shuzhi_1_red,
    icon_shuzhi_1_yellow,
    icon_shuzhi_2_blue,
    icon_shuzhi_2_green,
    icon_shuzhi_2_purple,
    icon_shuzhi_2_red,
    icon_shuzhi_2_yellow,
    icon_shuzhi_3_blue,
    icon_shuzhi_3_green,
    icon_shuzhi_3_purple,
    icon_shuzhi_3_red,
    icon_shuzhi_3_yellow,
    icon_shuzhi_4_blue,
    icon_shuzhi_4_green,
    icon_shuzhi_4_purple,
    icon_shuzhi_4_red,
    icon_shuzhi_4_yellow,
    
    icon_zhuangtai_1_blue,
    icon_zhuangtai_1_green,
    icon_zhuangtai_1_purple,
    icon_zhuangtai_1_red,
    icon_zhuangtai_1_yellow,
    icon_zhuangtai_2_blue,
    icon_zhuangtai_2_green,
    icon_zhuangtai_2_purple,
    icon_zhuangtai_2_red,
    icon_zhuangtai_2_yellow,
    icon_zhuangtai_3_blue,
    icon_zhuangtai_3_green,
    icon_zhuangtai_3_purple,
    icon_zhuangtai_3_red,
    icon_zhuangtai_3_yellow,
    icon_zhuangtai_4_blue,
    icon_zhuangtai_4_green,
    icon_zhuangtai_4_purple,
    icon_zhuangtai_4_red,
    icon_zhuangtai_4_yellow,
    
    icon_zuzhi_1_blue,
    icon_zuzhi_1_green,
    icon_zuzhi_1_purple,
    icon_zuzhi_1_red,
    icon_zuzhi_1_yellow,
    icon_zuzhi_2_blue,
    icon_zuzhi_2_green,
    icon_zuzhi_2_purple,
    icon_zuzhi_2_red,
    icon_zuzhi_2_yellow,
    icon_zuzhi_3_blue,
    icon_zuzhi_3_green,
    icon_zuzhi_3_purple,
    icon_zuzhi_3_red,
    icon_zuzhi_3_yellow,
    icon_zuzhi_4_blue,
    icon_zuzhi_4_green,
    icon_zuzhi_4_purple,
    icon_zuzhi_4_red,
    icon_zuzhi_4_yellow,
        
    bipg_tongyong_1_blue,
    bipg_tongyong_1_green,
    bipg_tongyong_1_purple,
    bipg_tongyong_1_red,
    bipg_tongyong_1_yellow,
    bipg_tongyong_2_blue,
    bipg_tongyong_2_green,
    bipg_tongyong_2_purple,
    bipg_tongyong_2_red,
    bipg_tongyong_2_yellow,
    bipg_tongyong_3_blue,
    bipg_tongyong_3_green,
    bipg_tongyong_3_purple,
    bipg_tongyong_3_red,
    bipg_tongyong_3_yellow,
    bipg_tongyong_4_blue,
    bipg_tongyong_4_green,
    bipg_tongyong_4_purple,
    bipg_tongyong_4_red,
    bipg_tongyong_4_yellow,

    bipg_renyuan_1_blue,
    bipg_renyuan_1_green,
    bipg_renyuan_1_purple,
    bipg_renyuan_1_red,
    bipg_renyuan_1_yellow,
    bipg_renyuan_2_blue,
    bipg_renyuan_2_green,
    bipg_renyuan_2_purple,
    bipg_renyuan_2_red,
    bipg_renyuan_2_yellow,
    bipg_renyuan_3_blue,
    bipg_renyuan_3_green,
    bipg_renyuan_3_purple,
    bipg_renyuan_3_red,
    bipg_renyuan_3_yellow,
    bipg_renyuan_4_blue,
    bipg_renyuan_4_green,
    bipg_renyuan_4_purple,
    bipg_renyuan_4_red,
    bipg_renyuan_4_yellow,

    bipg_riqi_1_blue,
    bipg_riqi_1_green,
    bipg_riqi_1_purple,
    bipg_riqi_1_red,
    bipg_riqi_1_yellow,
    bipg_riqi_2_blue,
    bipg_riqi_2_green,
    bipg_riqi_2_purple,
    bipg_riqi_2_red,
    bipg_riqi_2_yellow,
    bipg_riqi_3_blue,
    bipg_riqi_3_green,
    bipg_riqi_3_purple,
    bipg_riqi_3_red,
    bipg_riqi_3_yellow,
    bipg_riqi_4_blue,
    bipg_riqi_4_green,
    bipg_riqi_4_purple,
    bipg_riqi_4_red,
    bipg_riqi_4_yellow,

    bipg_shuzhi_1_blue,
    bipg_shuzhi_1_green,
    bipg_shuzhi_1_purple,
    bipg_shuzhi_1_red,
    bipg_shuzhi_1_yellow,
    bipg_shuzhi_2_blue,
    bipg_shuzhi_2_green,
    bipg_shuzhi_2_purple,
    bipg_shuzhi_2_red,
    bipg_shuzhi_2_yellow,
    bipg_shuzhi_3_blue,
    bipg_shuzhi_3_green,
    bipg_shuzhi_3_purple,
    bipg_shuzhi_3_red,
    bipg_shuzhi_3_yellow,
    bipg_shuzhi_4_blue,
    bipg_shuzhi_4_green,
    bipg_shuzhi_4_purple,
    bipg_shuzhi_4_red,
    bipg_shuzhi_4_yellow,

    bipg_zhuangtai_1_blue,
    bipg_zhuangtai_1_green,
    bipg_zhuangtai_1_purple,
    bipg_zhuangtai_1_red,
    bipg_zhuangtai_1_yellow,
    bipg_zhuangtai_2_blue,
    bipg_zhuangtai_2_green,
    bipg_zhuangtai_2_purple,
    bipg_zhuangtai_2_red,
    bipg_zhuangtai_2_yellow,
    bipg_zhuangtai_3_blue,
    bipg_zhuangtai_3_green,
    bipg_zhuangtai_3_purple,
    bipg_zhuangtai_3_red,
    bipg_zhuangtai_3_yellow,
    bipg_zhuangtai_4_blue,
    bipg_zhuangtai_4_green,
    bipg_zhuangtai_4_purple,
    bipg_zhuangtai_4_red,
    bipg_zhuangtai_4_yellow,

    bipg_zuzhi_1_blue,
    bipg_zuzhi_1_green,
    bipg_zuzhi_1_purple,
    bipg_zuzhi_1_red,
    bipg_zuzhi_1_yellow,
    bipg_zuzhi_2_blue,
    bipg_zuzhi_2_green,
    bipg_zuzhi_2_purple,
    bipg_zuzhi_2_red,
    bipg_zuzhi_2_yellow,
    bipg_zuzhi_3_blue,
    bipg_zuzhi_3_green,
    bipg_zuzhi_3_purple,
    bipg_zuzhi_3_red,
    bipg_zuzhi_3_yellow,
    bipg_zuzhi_4_blue,
    bipg_zuzhi_4_green,
    bipg_zuzhi_4_purple,
    bipg_zuzhi_4_red,
    bipg_zuzhi_4_yellow,
};